"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _fontIcon = _interopRequireWildcard(require("../../atoms/font-icon"));

var _content = _interopRequireWildcard(require("../../atoms/content"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _tokens = require("../../../tokens");

var _spacing = _interopRequireDefault(require("../../../tokens/spacing"));

var _pixelcalculations = require("../../_utils/pixelcalculations");

var _versions = require("../../_utils/versions");

var _tooltip = _interopRequireDefault(require("../../atoms/tooltip"));

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height:20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: ", ";\n  width: max-content;\n  max-width: ", ";\n  box-sizing: border-box;\n  text-transform: uppercase;\n  text-align: center;\n  background: ", ";\n  border: ", ";\n  border-radius: 15px;\n  color: ", ";\n  padding: 0 0 0 10px;\n  margin: ", ";\n  opacity: ", ";\n\n  ", " {\n    margin-right: 10px;\n  }\n\n  ", ":last-child {\n    margin: 0 10px;\n    color: ", ";\n  }\n\n  ", " {\n    overflow: hidden;\n    white-space: nowrap;\n    width: 90%;\n    text-overflow: ellipsis;\n  }\n\n  button {\n    font: initial;\n    line-height: normal;\n    font-size: initial;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          > *:last-child {\n            margin-right: 0;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          flex-direction: column;\n          > *:last-child {\n            margin-bottom: 0;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'chip');
};

var getViews = function getViews(props) {
  var colors = getColors(props);
  return {
    "default": {
      text: colors["default"].text,
      icon: colors["default"].icon,
      background: colors["default"].background,
      border: colors["default"].border
    },
    inverted: {
      text: colors.inverted.text,
      icon: colors.inverted.icon,
      background: colors.inverted.background,
      border: colors.inverted.border
    }
  };
};

var sizes = {
  "default": {
    lineHeight: (0, _pixelcalculations.subtract)(_tokens.misc.badge["default"].height, '2px'),
    minWidth: '72px',
    maxWidth: '280px'
  }
};

var getStyles = function getStyles(props) {
  var viewStyles = getViews(props)[props.view] ? getViews(props)[props.view] : getViews(props)["default"];
  var sizeStyles = sizes[props.size] ? sizes[props.size] : sizes["default"];

  var styles = _objectSpread({}, viewStyles, sizeStyles);

  if (props.icon && !props.text) {
    styles.padding = 0;
    styles.minWidth = '36px';
  }

  return styles;
};

var StyledChips = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.layout === 'vertical' ? (0, _styledComponents.css)(_templateObject2()) : (0, _styledComponents.css)(_templateObject3());
});

var Chips =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Chips, _React$Component);

  //eslint-disable-line
  function Chips(props) {
    var _this;

    _classCallCheck(this, Chips);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chips).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      _this.setState({
        chips: _react["default"].Children.toArray(nextProps.children)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (v) {
      _this.setState(function (prevState) {
        return {
          chips: prevState.chips.filter(function (chip) {
            return chip.props.value !== v;
          })
        };
      });

      _this.props.onDelete(v);
    });

    _this.state = {
      chips: _react["default"].Children.toArray(_this.props.children)
    };
    return _this;
  }

  _createClass(Chips, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement(StyledChips, this.props, this.state.chips.map(function (chip) {
        return _react["default"].createElement(Chip, {
          key: chip.props.value,
          view: _this2.props.view,
          text: chip.props.children,
          icon: chip.props.icon,
          disabled: _this2.props.disabled || chip.props.disabled,
          onDelete: function onDelete() {
            return _this2.onDelete(chip.props.value);
          },
          version: _this2.props.version,
          bordered: _this2.props.bordered
        });
      }));
    }
  }]);

  return Chips;
}(_react["default"].Component);

var Chip = function Chip(props) {
  var content = [];

  if (props.icon) {
    content.push(_react["default"].createElement(_fontIcon["default"], {
      key: "icon",
      size: 14,
      color: getStyles(props).icon
    }, props.icon));
  }

  content.push(_react["default"].createElement(_content["default"], {
    key: "text",
    highlight: true,
    color: getStyles(props).icon
  }, props.text), _react["default"].createElement(_button["default"], {
    view: "plain",
    size: "small",
    key: "close",
    icon: 'icon-close',
    disabled: props.disabled,
    onClick: props.onDelete,
    iconColor: getStyles(props).icon,
    height: "20px"
  }, _react["default"].createElement(_fontIcon["default"], {
    size: 11
  }, "icon-close")));
  return _react["default"].createElement(Chip.Element, props, content);
};

Chip.Element = _styledComponents["default"].div(_templateObject4(), function (props) {
  return getStyles(props).minWidth;
}, function (props) {
  return getStyles(props).maxWidth;
}, function (props) {
  return getStyles(props).background;
}, function (props) {
  return props.bordered && "1px solid ".concat(getStyles(props).border);
}, function (props) {
  return getStyles(props).text;
}, _spacing["default"].xsmall, function (props) {
  return props.disabled ? 0.5 : 1;
}, _fontIcon.StyledIcon, _fontIcon.StyledIcon, function (props) {
  return getStyles(props).text;
}, _content.StyledContent);

Chips.Chip = function (props) {
  return _react["default"].createElement(Chip, props);
};

Chips.propTypes = {
  /** Layout information */
  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** The visual style used to convey the button's purpose */
  view: _propTypes["default"].oneOf(['default', 'inverted']),

  /** Disables every chip. Use disabled flag with individual chips to disable only the applied upon */
  disabled: _propTypes["default"].bool,
  bordered: _propTypes["default"].bool,

  /** onDelete handler */
  onDelete: _propTypes["default"].func
};
Chips.defaultProps = {
  layout: 'horizontal',
  view: 'default',
  bordered: true
};
Chips.displayName = 'Chips';

var _default = (0, _context.withVersion)(Chips);

exports["default"] = _default;